// middleware/auth.global.ts
export default defineNuxtRouteMiddleware((to, from) => {
    // const userStore = useUserStore();
    //
    // // Check if the route starts with '/app' and the user is not authenticated
    // if (to.path.startsWith('/app') && !userStore.isAuthenticated) {
    //     // Redirect to the sign-in page
    //     return navigateTo('/sign-in');
    // }
});